import { render, staticRenderFns } from "./userGuide.vue?vue&type=template&id=b6a84462&"
import script from "./userGuide.vue?vue&type=script&lang=js&"
export * from "./userGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports